<template>
  <transition name="slide">
    <div v-if="isVisible" class="fixed bottom-0 left-0 right-0 bg-gray-800/95 text-white px-3 py-2.5 sm:p-4 flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-4 shadow-lg z-[99999] min-h-[64px] sm:min-h-[72px] pb-[calc(0.625rem+env(safe-area-inset-bottom,0px))]">
      <div class="space-y-1 max-w-2xl w-full sm:w-auto">
        <p class="text-gray-300 text-xs sm:text-sm leading-snug">
          {{ t('cookiesBanner.message') }}
          <span class="hidden sm:inline">
            —
            <router-link to="/cookies" class="text-blue-400 hover:text-blue-300 underline ml-1">
              {{ t('cookiesBanner.cookiesPolicyLink') }}
            </router-link>
            ·
            <router-link to="/privacy-policy" class="text-blue-400 hover:text-blue-300 underline">
              {{ t('cookiesBanner.privacyPolicyLink') }}
            </router-link>
          </span>
        </p>
        <div class="flex sm:hidden items-center gap-x-3 text-xs">
          <router-link to="/cookies" class="text-blue-400 hover:text-blue-300 underline">
            {{ t('cookiesBanner.cookiesPolicyLink') }}
          </router-link>
          <router-link to="/privacy-policy" class="text-blue-400 hover:text-blue-300 underline">
            {{ t('cookiesBanner.privacyPolicyLink') }}
          </router-link>
        </div>
      </div>
      <div class="flex gap-2 sm:gap-3 flex-shrink-0 w-full sm:w-auto justify-end">
        <button
          @click="reject"
          class="px-4 py-2 text-sm rounded border border-gray-600 hover:bg-gray-700 transition-colors whitespace-nowrap"
        >
          {{ t('cookiesBanner.rejectButton') }}
        </button>
        <button
          @click="accept"
          class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 text-sm rounded transition-colors whitespace-nowrap"
        >
          {{ t('cookiesBanner.acceptButton') }}
        </button>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import {
  grantAllCookieConsent,
  revokeOptionalCookieConsent,
  hasCookieConsentChoice,
} from '@/utils/analyticsConsent'

const isVisible = ref(false)
const emit = defineEmits(['accept', 'reject'])
const { t } = useI18n()
const router = useRouter()

function accept() {
  grantAllCookieConsent(router)
  isVisible.value = false
  document.body.classList.add('cookies-accepted')
  emit('accept')
}

function reject() {
  revokeOptionalCookieConsent()
  isVisible.value = false
  document.body.classList.add('cookies-accepted')
  emit('reject')
}

onMounted(() => {
  if (!hasCookieConsentChoice()) {
    isVisible.value = true
  } else {
    document.body.classList.add('cookies-accepted')
  }
})
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease-in-out;
  position: relative;
  z-index: 99999;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(100%);
}
</style>
